'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Represents a chord with the corresponding (partial) lyrics
 */
var ChordLyricsPair = function () {
  /**
   * Initialises a ChordLyricsPair
   * @param {string} chords The chords
   * @param {string} lyrics The lyrics
   */
  function ChordLyricsPair() {
    var chords = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var lyrics = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    _classCallCheck(this, ChordLyricsPair);

    /**
     * The chords
     * @member
     * @type {string}
     */
    this.chords = chords;

    /**
     * The lyrics
     * @member
     * @type {string}
     */
    this.lyrics = lyrics;
  }

  /**
   * Indicates whether a ChordLyricsPair should be visible in a formatted chord sheet (except for ChordPro sheets)
   * @returns {boolean}
   */


  _createClass(ChordLyricsPair, [{
    key: 'isRenderable',
    value: function isRenderable() {
      return true;
    }

    /**
     * Returns a deep copy of the ChordLyricsPair, useful when programmatically transforming a song
     * @returns {ChordLyricsPair}
     */

  }, {
    key: 'clone',
    value: function clone() {
      return new ChordLyricsPair(this.chords, this.lyrics);
    }
  }, {
    key: 'toString',
    value: function toString() {
      return 'ChordLyricsPair(chords=' + this.chords + ', lyrics=' + this.lyrics + ')';
    }
  }]);

  return ChordLyricsPair;
}();

exports.default = ChordLyricsPair;


//////////////////
// WEBPACK FOOTER
// ./~/chordsheetjs/lib/chord_sheet/chord_lyrics_pair.js
// module id = 20
// module chunks = 1